import { AlertColor, Grid } from "@mui/material";
import Iconborder from "../IconBorder";
import { Apartment } from "@mui/icons-material";
import { KeyDriveh4Header } from "../../../../../components/KeydriveComponents/Fonts/Headers/KeyDriveh4Header";
import { KeyDriveBodyMin } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { useTranslation } from "react-i18next";
import { KeydriveTextfield } from "../../../../../components/KeydriveComponents/Textfield/KeydriveTextfield";
import { IRegisterUserObject } from "../../Register";
import ForwardBackButton from "../ForwardBackButton";

interface IRegisterOrganization {
    createUserObject: IRegisterUserObject;
    organizationHandler: (input: string) => void;
    forwardStep: () => void;
    backStep: () => void;
    setAlertColor: (set: AlertColor) => void;
    setMessage: (set: string) => void;
}

export default function RegisterOrganization({
    createUserObject,
    organizationHandler,
    backStep,
    forwardStep,
    setAlertColor,
    setMessage
}: IRegisterOrganization): JSX.Element {

    const { t } = useTranslation();

    return (
        <>
            <Grid item xs={12} display="flex" justifyContent="center" marginBottom="12px">
                <Iconborder>
                    <Apartment sx={{ color: "#22638D", width: "36px", height: "36px" }} />
                </Iconborder>
            </Grid>
            <Grid item xs={12} textAlign="center" marginBottom="20px">
                <KeyDriveh4Header
                    color={"#22638D"}
                    needBold
                    needEllipses={false}
                    text={t("RegisterPage.steps.step3.title")}
                    sxStyles={{
                        marginBottom: "12px"
                    }}
                />
                <KeyDriveBodyMin
                    color="#7AA1BB"
                    needBold={false}
                    needEllipses={false}
                    text={t("RegisterPage.steps.step3.content")}
                />
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="space-between" marginTop="12px">
                <KeydriveTextfield 
                    label={t("Register.OrgName")}
                    onChange={e => organizationHandler(e.target.value)}
                    value={createUserObject.organizationName}
                    placeholder="Digite aqui..."
                    needFullWidth
                    required
                />
            </Grid>
            <ForwardBackButton 
                backStep={backStep}
                forwardStep={() => {
                    if (createUserObject.organizationName == "") {
                        setMessage(t("Register.NullOrg"));
                        setAlertColor("error");
                        throw new Error();
                    }
                    forwardStep()
                }}
            />
        </>
    )
}